import React, {Component} from "react";
import {IconButton, Stack, Tooltip} from "@mui/material";
import ShareIcon from '@mui/icons-material/Share';
import {morphleBaseTheme1} from "../themes";
import {connect} from "react-redux";
import {convertGammaStateToUrlParams, convertMapStateToUrlParams} from "../utils/linkMakerUtils";
import {notifyInfo} from "../utils/display.notification";
import {copyToClipboard, isNull} from "../../../utils/utils";

class ShareLink extends Component {

    copyShareableLinkToClipboard = () => {
        let url = `${window.location.href.split("?")[0]}?`;
        if (isNull(this.props.displayedMapId)) {
            for (let mapId in this.props.mapsState)
                url += `${convertMapStateToUrlParams(this.props.mapsState[mapId])}#`;
        } else {
            url += `${convertMapStateToUrlParams(this.props.mapsState[this.props.activeMapId])}#`;
        }

        url += `?${convertGammaStateToUrlParams(this.props.gammaState)}`;
        copyToClipboard(url);
        notifyInfo('shareLink', "Shareable link copied to clipboard")
    }

    render() {
        return <Stack direction={"row"} spacing={1} justifyContent="flex-start" sx={{alignItems: 'center'}}>
            <Tooltip title={"Share PermaLink"} placement={"bottom"} className="share-slide-forTour">
                <IconButton size="small" onClick={this.copyShareableLinkToClipboard}>
                    <ShareIcon sx={{color: morphleBaseTheme1.palette.headBarIcon.primary, marginRight: '5px'}}/>
                </IconButton>
            </Tooltip>
        </Stack>
    }
}


const mapStateToProps = (state) => {
    let gammaState = state.gammaStateReducer;
    let {activeMapId, displayedMapId} = gammaState;
    return {
        activeMapId,
        displayedMapId,
        mapsState: state.mapsStateReducer,
        gammaState: state.gammaStateReducer,
    }
}
export default connect(mapStateToProps)(ShareLink)
